<template>
    <div class="w-full">

        <vx-card id="accessesDiv"  class="vs-con-loading__container">

            <h4 class="mb-3">{{ $t('Accesses') }}</h4>

            <vs-table ref="table" :data="tableData" class="mt-3" pagination search :maxItems="itemsPerPage">
                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <div>
                        <div class="mr-6 mb-6" style="float: left">
                            <p>{{ $t('StartTime') }}</p>
                            <flat-pickr :config="configDateTimePicker" v-model="startTime"/>
                        </div>
                        <div class="mb-6" style="float: left">
                            <p>{{ $t('EndTime') }}</p>
                            <flat-pickr :config="configDateTimePicker" v-model="endTime"/>
                        </div>
                    </div>

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableItems - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableItems }} of {{ tableItems }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=250">
                                <span>250</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=500">
                                <span>500</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=1000">
                                <span>1000</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th sort-key="terminal_name">{{ $t('TerminalName') }}</vs-th>
                    <vs-th sort-key="user_name">{{ $t('UserName') }}</vs-th>
                    <vs-th sort-key="time">{{ $t('Time') }}</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                        <vs-td :data="data[index].terminal_name">
                            {{ data[index].terminal_name }}
                        </vs-td>

                        <vs-td :data="data[index].user_name">
                            {{ data[index].user_name }}
                        </vs-td>

                        <vs-td :data="data[index].time">
                            {{ moment(data[index].time).format('YYYY/MM/DD HH:mm:ss') }}
                        </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </vx-card>
    </div>
</template>
<script>

    import flatPickr from 'vue-flatpickr-component'
    import 'flatpickr/dist/flatpickr.css'

    export default {
        components: {
            flatPickr
        },
        props: {
            dataURL: {
                type: String,
                required: true
            }
        },
        data() {
            return {

                itemsPerPage: 50,
                isMounted: false,

                accesses: [],

                startTime: null,
                endTime: null,

                configDateTimePicker: {
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    locale: {
                        firstDayOfWeek: 1
                    }
                }

            }
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#accessesDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get(`${this.dataURL  }?start_time=${  this.moment(this.startTime).unix()  }&end_time=${  this.moment(this.endTime).unix()}`)
                loadPromise.then(function(response) {
                    thisIns.accesses = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#accessesDiv > .con-vs-loading')
                })
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            tableItems() {
                if (this.isMounted) {
                    return this.$refs.table.queriedResults.length
                }
                return 0
            },
            tableData() {
                return this.accesses
            }
        },
        watch: {
            startTime() {
                this.loadData()
            },
            endTime() {
                this.loadData()
            }
        },
        mounted() {

            const currentTime = new Date()
            this.startTime = new Date(currentTime.getFullYear(), currentTime.getMonth(), currentTime.getDate())
            this.endTime = currentTime

            this.isMounted = true
            this.loadData()
        }
    }
</script>
